import _util from '../../utils/';

const departmentPositionService = {
    fetchDepartmentPositionList(params, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    initPosition(resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Create',
            success: resolve,
            error: reject
        })
    },
    addPosition(posts, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Post',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })
    },
    multiDeletePosition(deletes, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Delete',
            method: 'delete',
            data: deletes,
            success: resolve,
            error: reject
        })        
    },
    updatePosition(puts, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Put',
            method: 'put',
            data: puts,
            success: resolve,
            error: reject
        })       
    },
    initMovePosition(positionID, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Move?positionId=' + positionID,
            success: resolve,
            error: reject
        })         
    },
    movePosition(posts, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Move',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })         
    },
    exportPosition(resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Export',
            success: resolve,
            error: reject
        })         
    },
    downloadTemplate(resolve, reject) {
        _util.request({
            url: '/api/HRPosition/GetImportTemplate',
            success: resolve,
            error: reject
        });
    },
    importPosition(posts, resolve, reject) {
        _util.request({
            url: '/api/HRPosition/Import ',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })
    },
}

export default departmentPositionService;


// WEBPACK FOOTER //
// ./src/services/DepartmentStructure/department-position-service.js